module.exports = __webpack_public_path__ + "img/sushi-king-menu-05.f80587a6.png";